import { Button, Col, Form, Row, Tabs } from "antd";
import { complexDigitToman, isEmpty, validateInput } from "../../../tools/tools";
import { DatePicker as DatePickerJalali, JalaliLocaleListener } from "antd-jalali";

import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import IncressCharge from "../../auxiliary/incressCharge/charge";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import Loading from "../../auxiliary/loader/loading";
import WalletTransaction from "./list/wallet_transaction";
import WalletSharing from "./list/wallet_sharing";
import { Roles } from "../../../tools/services";

const AgentWallet = ({ wallet = 0, type = 0 }) => {
  const [t] = useTranslation("global");
  const nav = useNavigate();

  const [frmSearch] = Form.useForm();

  const [searchParam] = useSearchParams();

  const { _currentUser } = useSelector((state) => state?.another);
  const [openIncress, setOpenIncress] = useState(false);
  const [localInvoiceId, setLocalInvoiceId] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [isActive, setIsActive] = useState(false);

  const [duringDate, setduringDate] = useState([]);

  const bankRef = useRef("");

  const [tabChangeWallet, setTabChangeWallet] = useState("wallet_transaction");

  const handleChange = (item) => {
    setTabChangeWallet(item);
  };

  useEffect(() => {
    if (!isEmpty(searchParam.get("localInvoiceId"))) {
      const getLocalInvoiceID = searchParam.get("localInvoiceId");
      setLocalInvoiceId(getLocalInvoiceID);
      setOpenIncress(true);
    } else {
    }
  }, []);

  const handleCallBackCharge = (value) => {
    setIsLoading(true);
    if (value?.length > 0) {
      bankRef.current.innerHTML = value;
      document.querySelector('form[action="https://asan.shaparak.ir"]').submit();
    } else {
      setLocalInvoiceId("");
      setOpenIncress(false);
    }
    setIsLoading(false);
  };

  const typeText = (type) => {
    switch (type) {
      case 1:
        return "اعتبار کیف پول نماینده";
      case 2:
        return "اعتبار کیف پول بسته";
      case 3:
        return "اعتبار کیف پول شارژ";
      default:
        return "";
    }
  };

  const handleSearch = async (value) => {
    setIsActive(true);
    setduringDate([value?.duringdate[0].format("YYYY-MM-DD"), value?.duringdate[1].format("YYYY-MM-DD")]);
  };

  return (
    <>
      {" "}
      <IncressCharge
        open={openIncress}
        planid={process.env.REACT_APP_PLANID_CHARGE_WALLET}
        msisdn={_currentUser?.telnoone}
        price={0}
        callback={handleCallBackCharge}
        localInvoiceId={localInvoiceId}
        activePrice={true}
      />
      <div ref={bankRef}></div>
      <div className="holder-box-wallet">
        <div className="row-item">
          <div className="holder-text">
            <p>
              <i className="icon-wallet" /> {typeText(type)}
            </p>
            <h2>
              <span dir="ltr">{complexDigitToman(wallet)}</span> تومان
            </h2>
          </div>
          <div className="holder-action">
            <div className="holder-button">
              {/* {type === 1 && (
                <Button
                  className="btn-normal"
                  onClick={() => nav(_adr.Root + _adr.Wallet.Index + _adr.Wallet.Withdraw.Index + _adr.Wallet.Withdraw.Change)}
                >
                  برداشت نقدی از اعتبار
                </Button>
              )} */}

              <Button className="btn-normal" onClick={() => setOpenIncress(true)}>
                شارژ کیف پول
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="holder-search-area">
        <div className="normal-search">
          <Form form={frmSearch} onFinish={handleSearch} layout="vertical">
            <Row gutter={30}>
              <Col>
                <JalaliLocaleListener />
                <Form.Item
                  name="duringdate"
                  className="input-normal"
                  label="انتخاب تاریخ"
                  rules={[validateInput({ t: t, validate: true, typeOfValue: "array" })]}
                >
                  <DatePickerJalali.RangePicker format={"YYYY/MM/DD"} />
                </Form.Item>
              </Col>
              <Col>
                <Form.Item label="&nbsp;">
                  <Button htmlType="submit" className="btn-normal btn-green">
                    جستجو
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
        {isActive && (
          <div className="holder-result">
            <div className="holder-tab">
              {type === 1 && (
                <Tabs
                  onChange={handleChange}
                  className="tab-wallet"
                  items={[
                    {
                      key: "wallet_transaction",
                      label: "گزارش تراکنش کیف پول ",
                    },
                    _currentUser?.roles?.includes(Roles.Dealer_Wallet_Report_RevenueShare) && {
                      key: "wallet_sharing",
                      label: "گزارش تراکنش تسهیم درآمد",
                    },
                  ]}
                />
              )}
            </div>
            <div className="holder-table">
              {tabChangeWallet === "wallet_transaction" && <WalletTransaction isActive={isActive} type={type} search={duringDate} />}
              {tabChangeWallet === "wallet_sharing" && <WalletSharing isActive={isActive} type={type} search={duringDate} />}
            </div>
          </div>
        )}
      </div>
      <Loading isOpen={isLoading} />
    </>
  );
};

export default AgentWallet;
